import {isWholeLife, PersonInsurance} from '@emma-labs/shared/typescript';

export interface Product {
  type: ProductType;
  name: string;
}

export enum ProductType {
  TERM_LIFE = 'TERM_LIFE',
  WHOLE_LIFE = 'WHOLE_LIFE',
  RIDER = 'RIDER',
}

export function getProducts(insurances: Pick<PersonInsurance, 'duration' | 'riders'>[]): Product[] {
  const productTypes: Product[] = [];

  insurances.forEach((insurance) => {
    if (isWholeLife(insurance.duration)) {
      productTypes.push({type: ProductType.WHOLE_LIFE, name: insurance.duration});
    } else {
      productTypes.push({type: ProductType.TERM_LIFE, name: insurance.duration});
    }

    insurance.riders?.forEach((rider) => {
      productTypes.push({type: ProductType.RIDER, name: rider.type});
    });
  });

  return productTypes;
}
